<script setup>
import {reactive, onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  search: null,
  dataLoading: true,
  headers: [
    { title: 'Person', key: 'person' },
    { title: 'Claim Number', key: 'claim' },
    { title: 'Date', key: 'date' },
    { title: 'Amount', key: 'amount' },
  ],
  items: [],
});

onMounted(()=>{
  // let contextId = new URLSearchParams(window.location.search).get(
  //     'contextIdA'
  // );
  // if (contextId === null) {
    ApiWrapper.get('holdbacks', 'outstanding-holdbacks')
        .then((response) => {
          if(response.holdbacks){
            data.items = response.holdbacks;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  // } else {
  //   ApiWrapper.get('Holdbacks', 'OutstandingPayPeriod/?contextId=' + contextId)
  //       .then((response) => {
  //         data.items = response.holdbacks;
  //       })
  //       .catch((e) => {
  //          ToastUtil.error(e);
  //        });
  // }
  // data.dataLoading = false;
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Outstanding Holdbacks</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.claim`]="{ item }">
          <RouterLink :to="`/claim/${item.claim}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span>{{ item.amountFormatted }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>